module.exports = __webpack_public_path__ + "static/powerbi-get-data-35274beb8b292e48a527207ecf51dcc3.gif";